import { z } from 'zod';

// ─── Tenant Competitor Settings ─────────────────────────────────────
// API-facing DTOs for per-tenant, per-industry competitor configuration.

export const TenantCompetitorSettingsResponseSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  industry: z.string(),
  industryCompetitors: z.string().nullable(),
  mainCompetitor: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type TenantCompetitorSettingsResponse = z.infer<typeof TenantCompetitorSettingsResponseSchema>;

export const CreateTenantCompetitorSettingsBodySchema = z.object({
  industry: z.string().min(1).max(255),
  industryCompetitors: z.string().nullish(),
  mainCompetitor: z.string().max(255).nullish(),
});
export type CreateTenantCompetitorSettingsBody = z.infer<typeof CreateTenantCompetitorSettingsBodySchema>;

export const UpdateTenantCompetitorSettingsBodySchema = z.object({
  industryCompetitors: z.string().nullish(),
  mainCompetitor: z.string().max(255).nullish(),
});
export type UpdateTenantCompetitorSettingsBody = z.infer<typeof UpdateTenantCompetitorSettingsBodySchema>;
